import React from "react";
import { Phone, Mail, MapPin, Clock, ShieldAlert } from "lucide-react";
import { PageHeader, Section, Card } from "../components/ui-kit";
import { EnquiryForm } from "../components/EnquiryForm";
import { useContact } from "../context/SiteSettingsContext";

export default function Contact() {
  const CONTACT = useContact();
  return (
    <>
      <PageHeader
        eyebrow="Contact and enquiries"
        title="Get in touch"
        intro="We would love to hear from you. Use the form to make an enquiry, or contact us directly using the details below."
        testid="contact-header"
      />
      <Section tone="default">
        <div className="grid gap-12 lg:grid-cols-2">
          {/* Contact details */}
          <div className="space-y-6">
            <Card>
              <h2 className="font-heading text-2xl font-semibold text-stone-900">Contact details</h2>
              <ul className="mt-6 space-y-5">
                <li className="flex items-start gap-4">
                  <Phone className="h-6 w-6 text-orange-700 shrink-0 mt-0.5" aria-hidden="true" />
                  <div>
                    <p className="text-sm text-stone-500">Phone</p>
                    <p className="text-lg font-medium text-stone-900">{CONTACT.phone}</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <Mail className="h-6 w-6 text-orange-700 shrink-0 mt-0.5" aria-hidden="true" />
                  <div>
                    <p className="text-sm text-stone-500">Email</p>
                    <p className="text-lg font-medium text-stone-900">{CONTACT.email}</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <MapPin className="h-6 w-6 text-orange-700 shrink-0 mt-0.5" aria-hidden="true" />
                  <div>
                    <p className="text-sm text-stone-500">Address</p>
                    <p className="text-lg font-medium text-stone-900">{CONTACT.address}</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <Clock className="h-6 w-6 text-orange-700 shrink-0 mt-0.5" aria-hidden="true" />
                  <div>
                    <p className="text-sm text-stone-500">Opening hours</p>
                    <p className="text-lg font-medium text-stone-900">{CONTACT.hours}</p>
                  </div>
                </li>
              </ul>
            </Card>

            <div className="rounded-2xl border-2 border-red-200 bg-red-50 p-6" data-testid="urgent-notice">
              <div className="flex items-start gap-3">
                <ShieldAlert className="h-6 w-6 text-red-700 shrink-0 mt-0.5" aria-hidden="true" />
                <div>
                  <h2 className="font-heading text-lg font-semibold text-stone-900">
                    Urgent or safeguarding concerns
                  </h2>
                  <p className="mt-1 text-base text-stone-800 leading-relaxed">
                    For urgent matters, please contact us directly using the phone number above. For
                    safeguarding concerns, use our safeguarding contact: {CONTACT.safeguarding}. If
                    someone is in immediate danger, contact the emergency services.
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Form */}
          <Card>
            <h2 className="font-heading text-2xl font-semibold text-stone-900">Make an enquiry</h2>
            <p className="mt-2 text-lg text-stone-700">
              Fields are required. We will reply using your preferred contact method.
            </p>
            <div className="mt-6">
              <EnquiryForm />
            </div>
          </Card>
        </div>
      </Section>
    </>
  );
}
